import React from 'react';
import type { LinkProps } from '@chakra-ui/next-js';
import { useShallow } from 'zustand/react/shallow';

import { Button, type ButtonProps, Link } from '@/components';
import { useBasketStore, useProfile, useTranslation } from '@/hooks';
import { productCount } from '@/utils';

type Prop = {
  content_bank_link: string | null;
  code: number;
};

const ContentBankLink: React.FC<Prop> = ({ content_bank_link, code }) => {
  const { data: profile } = useProfile();
  const { t } = useTranslation('pages.products');
  const [count] = useBasketStore(
    useShallow((state) => [
      productCount({ products: state.products, code: code }),
    ])
  );

  const commonProps: ButtonProps & LinkProps = {
    justifyContent: 'center',
    type: 'submit',
    as: Link,
    href: content_bank_link || '',
    variant: 'outline',
    target: '_blank',
    textAlign: 'center',
    fontSize: 'lg',
  };

  return content_bank_link && profile?.user_type === 'agent' ? (
    <>
      <Button
        {...commonProps}
        w="full"
        display={{ base: 'block', md: 'none' }}
        lineHeight="16px"
      >
        {t('contentBank')}
      </Button>
      <Button
        {...commonProps}
        size={count === 0 ? 'md' : 'xl'}
        display={{ base: 'none', md: 'block' }}
      >
        {t('contentBank')}
      </Button>
    </>
  ) : null;
};

export default ContentBankLink;
